// Preview is handled in src/pages/preview.js
export default ({ children }) => children;
